import React, { memo } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";

const BedroomFields = () => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext(); // Access form context

  const watchFieldArray = watch("bedrooms");

  const { fields, append, remove } = useFieldArray({
    control, // Pass the control object from `useForm`
    name: "bedrooms", // Name of the field array
  });

  // Combine field metadata and watched values for each dependant
  const bedroomsList = fields.map((field, index) => {
    return {
      ...field, // Include field metadata from `useFieldArray`
      ...watchFieldArray?.[index], // Include watched values from `watch`
    };
  });
  return (
    <div className="mt-4">
      <h4 className="mb-2 text-2xl font-bold">Bedrooms</h4>
      {bedroomsList?.map((bedroom, index) => {
        return (
          <div
            key={bedroom.id}
            className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-4"
            id="bedrooms"
          >
            <div className="col-span-1">
              <label
                htmlFor={`bedrooms[${index}].name`}
                className="mb-1 block text-sm font-medium text-gray-700"
              >
                Bedroom Name
              </label>
              <Controller
                name={`bedrooms[${index}].name`}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <div className="relative">
                    <input
                      id={`bedrooms[${index}].name`}
                      type="text"
                      className={`w-full rounded-md border px-4 py-3  ${
                        errors.bedrooms?.[index]?.name?.message
                          ? "border-red-500"
                          : "border-gray-300"
                      }`}
                      placeholder="e.g. Master Bedroom"
                      value={value}
                      onChange={onChange}
                    />
                    {errors.bedrooms?.[index]?.name?.message && (
                      <p className="mt-1 text-sm text-red-500">
                        {errors.bedrooms?.[index]?.name?.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>
            <div className="col-span-1">
              <label
                htmlFor={`bedrooms[${index}].no_of_guest`}
                className="mb-1 block text-sm font-medium text-gray-700"
              >
                Number of Guests
              </label>
              <Controller
                name={`bedrooms[${index}].no_of_guest`}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <div className="relative">
                    <input
                      id={`bedrooms[${index}].no_of_guest`}
                      type="number"
                      className={`w-full rounded-md border px-4 py-3  ${
                        errors.bedrooms?.[index]?.no_of_guest?.message
                          ? "border-red-500"
                          : "border-gray-300"
                      }`}
                      placeholder="e.g. 2"
                      value={value}
                      onChange={onChange}
                    />
                    {errors.bedrooms?.[index]?.no_of_guest?.message && (
                      <p className="mt-1 text-sm text-red-500">
                        {errors.bedrooms?.[index]?.no_of_guest?.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>
            <div className="col-span-1">
              <label
                htmlFor={`bedrooms[${index}].no_of_bed`}
                className="mb-1 block text-sm font-medium text-gray-700"
              >
                Number of Beds
              </label>
              <Controller
                name={`bedrooms[${index}].no_of_bed`}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <div className="relative">
                    <input
                      id={`bedrooms[${index}].no_of_bed`}
                      type="number"
                      className={`w-full rounded-md border px-4 py-3  ${
                        errors.bedrooms?.[index]?.no_of_bed?.message
                          ? "border-red-500"
                          : "border-gray-300"
                      }`}
                      placeholder="e.g. 1"
                      value={value}
                      onChange={onChange}
                    />
                    {errors.bedrooms?.[index]?.no_of_bed?.message && (
                      <p className="mt-1 text-sm text-red-500">
                        {errors.bedrooms?.[index]?.no_of_bed?.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>
            <div className="col-span-1">
              <label
                htmlFor={`bedrooms[${index}].bed_type`}
                className="mb-1 block text-sm font-medium text-gray-700"
              >
                Bed Type
              </label>
              <Controller
                name={`bedrooms[${index}].bed_type`}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <div className="relative">
                    <input
                      id={`bedrooms[${index}].bed_type`}
                      className={`w-full rounded-md border px-4 py-3  ${
                        errors.bedrooms?.[index]?.bed_type?.message
                          ? "border-red-500"
                          : "border-gray-300"
                      }`}
                      placeholder="e.g. King"
                      value={value}
                      onChange={onChange}
                    />
                    {errors.bedrooms?.[index]?.bed_type?.message && (
                      <p className="mt-1 text-sm text-red-500">
                        {errors.bedrooms?.[index]?.bed_type?.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>
            <div className="col-span-4 flex justify-end">
              <button
                type="button"
                className="rounded-md border border-red-500 bg-white px-4 py-2 text-sm font-medium text-red-500 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                onClick={() => remove(index)}
              >
                Remove bedroom
              </button>
            </div>
          </div>
        );
      })}

      <button
        type="button"
        className="mt-2 rounded-md border border-red-500 border-solid bg-white px-4 py-2 text-sm font-medium text-red-500 shadow-sm hover:bg-red-50 focus:outline-none "
        onClick={() => {
          append({
            name: "",
            no_of_guest: "",
            no_of_bed: "",
            bed_type: "",
          });
        }}
      >
        Add new bedroom
      </button>
    </div>
  );
};

export default memo(BedroomFields);
